import useBrandingDay, { BrandingDayOptionsType } from '@hooks/useBrandingDay'
import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import { printCSS } from '@utils/style'

type StyledBrandingDay = Pick<
  BrandingDayOptionsType,
  'bgColor' | 'bgFixed' | 'bgImgUrl' | 'bgCover' | 'paddingTop'
> & { isVisible: boolean }

const StyledBrandingDay = styled.div<StyledBrandingDay>`
  ${({ bgColor, bgFixed, bgImgUrl, bgCover, paddingTop, isVisible }) =>
    !isVisible
      ? css`
          display: none;
        `
      : css`
          display: block;
          position: sticky;
          top: 62px;
          left: 0;
          width: 100vw;
          height: calc(100vh - 62px);
          background-repeat: no-repeat;
          ${bgColor && `background-color: ${bgColor};`}
          background-attachment: ${bgFixed ? 'fixed' : 'scroll'};
          ${bgImgUrl && `background-image: url('${bgImgUrl}');`}
          background-repeat: 'no-repeat';
          ${bgCover && 'background-size: cover;'}
          background-position: ${paddingTop
            ? `center ${paddingTop}px`
            : 'center'};
        `}
`

const BrandingDayWrapper = styled.div`
  ${({
    theme: {
      colors: { white },
    },
  }) => css`
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${white};
    ${printCSS(css`
      display: none;
    `)}
  `}
`

const BrandingDay: FunctionComponent = () => {
  const { isVisible, options } = useBrandingDay()

  const { bgColor, bgFixed, bgImgUrl, bgCover, paddingTop } = options ?? {}
  return (
    <BrandingDayWrapper>
      {!!options && (
        <StyledBrandingDay
          bgColor={bgColor}
          bgFixed={bgFixed}
          bgImgUrl={bgImgUrl}
          bgCover={bgCover}
          paddingTop={paddingTop}
          isVisible={isVisible}
        />
      )}
    </BrandingDayWrapper>
  )
}

export default BrandingDay
